import React from 'react';

import css from './SideBar.module.css';
import {MenuTitle} from "../MenuTitle/MenuTitle";
import {UlForMenu} from "../UlForMenu/UlForMenu";
import {LogOutComponent} from "../LogOutComponent/LogOutComponent";
import {LanguageSelectComponent} from "../LanguageSelectComponent/LanguageSelectComponent";


const SideBar = ({ onMenuClose, isMobile }) => {
    return (
        <section className={css.wrap}>
            <section className={css.infoMenuBlock}>
                <MenuTitle isMobile={isMobile} />
                <UlForMenu onMenuClose={onMenuClose} isMobile={isMobile} />
                <LogOutComponent isMobile={isMobile} />
            </section>

            <section className={css.languageBlock}>
                <LanguageSelectComponent isMobile={isMobile} />
            </section>
        </section>
    );
};

export {SideBar};